import { Injectable } from '@angular/core';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
import { DynamicComponentGridFormGetMetaInfoRequest, DynamicComponentGridFormGetMetaInfoResponse, DynamicComponentGridFormUpdateRequest, DynamicComponentGridFormUpdateResponse } from './model/models';
import { DynamicComponentGridFormGetPageRequest } from './model/dynamicComponentGridFormGetPageRequest';
import { DynamicComponentGridFormGetPageResponse } from './model/dynamicComponentGridFormGetPageResponse';
import { DynamicComponentGridFormGetTotalRequest } from './model/dynamicComponentGridFormGetTotalRequest';
import { DynamicComponentGridFormGetTotalResponse } from './model/dynamicComponentGridFormGetTotalResponse';
@Injectable()
export class DynamicComponentGridFormService extends BaseService {
  private getMetaInfo_URL = 'metabase/dynamicComponentGridForm/getMetaInfo';
  private getPage_URL = 'metabase/dynamicComponentGridForm/getPage';
  private getTotal_URL = 'metabase/dynamicComponentGridForm/getTotal';
  private getUpdate_URL = 'metabase/dynamicComponentGridForm/update';
  private exportExcel_URL = 'metabase/dynamicComponentExportForm/exportExcel';
  constructor(private client: E8HttpClient) {
    super();
  }

  getMetaInfo(request: DynamicComponentGridFormGetMetaInfoRequest, options?: C8HttpClientOptions): Promise<DynamicComponentGridFormGetMetaInfoResponse> {
    return this.client.post(this.fUrl(this.getMetaInfo_URL), request, options);
  }

  getPage(request: DynamicComponentGridFormGetPageRequest, options?: C8HttpClientOptions): Promise<DynamicComponentGridFormGetPageResponse> {
    return this.client.post(this.fUrl(this.getPage_URL), request, options);
  }

  getTotal(request: DynamicComponentGridFormGetTotalRequest, options?: C8HttpClientOptions): Promise<DynamicComponentGridFormGetTotalResponse> {
    return this.client.post(this.fUrl(this.getTotal_URL), request, options);
  }
  update(request: DynamicComponentGridFormUpdateRequest, options?: C8HttpClientOptions): Promise<DynamicComponentGridFormUpdateResponse> {
    return this.client.post(this.fUrl(this.getUpdate_URL), request, options);
  }
  exportExcel(source: any,windowFormId: string, options?: C8HttpClientOptions) {
     this.client.exportExcel(this.fUrl(this.exportExcel_URL+"?windowFormId="+windowFormId), source);
  }

}
